export const pageMaintenanceProps = () => ({
  isTemp: {
    type: Boolean,
    required: false,
    default: false
  },
  borne: {
    type: Boolean,
    required: false,
    default: false
  }
})

export const usePageMaintenance = () => {
  const reload = () => {
    window.location.reload(true);
  }

  return { reload }
}